
import { defineComponent } from "vue";

export default defineComponent({
  name: "card-etat_emp",
  props: {
    cardClasses: String,
    icon: String,
    eem_libelle: String,
    eem_repas_mois: String,
    eem_kms_mois: String,
    eem_usage_voiture_perso: String,
    eem_usage_voiture_pro: String,
    eem_x_conges: String,
    eem_tot_heures_hno: String,
    color: String,
    arrow: String,
    eem_status: String,
    footerText: String,
    indicatorLabel: String,
    emp_prenom_nom: String
  },
setup() {

  const formatMilliers = (val: string | number | null | undefined) => {
    if (val === null || val === undefined || val === '') return '';
    const n = Number(val);
    if (!isFinite(n)) return String(val);

    return Math.trunc(n).toLocaleString('de-DE');
  };

  return {
    formatMilliers,
  };
},
});

